// ---------------------------------------------------------------------------------------------------------------------
// Load more functionality for ambassadors list
// ---------------------------------------------------------------------------------------------------------------------
// in init shows 8 ambassadors
// on each click shows 8 ambassadors more
// hide button if no more ambassadors
// ---------------------------------------------------------------------------------------------------------------------
var size_li = jQuery(".js_ambassador_item").length;
var initShow = 8
var eachClickShow = 8
var x = initShow;

jQuery('.js_ambassador_list .js_ambassador_item:lt(' + x + ')').show();

// Do not show load more for less than x + 1 item in list
if (x >= size_li) {
    jQuery('.js_ambassador_list_load_more').hide();
} else {
    jQuery('.js_ambassador_list_load_more').click(function (e) {
        e.preventDefault()
        x = (x + eachClickShow <= size_li) ? x + eachClickShow : size_li;
        jQuery('.js_ambassador_list .js_ambassador_item:lt(' + x + ')').show();

        if (x == size_li) {
            jQuery('.js_ambassador_list_load_more').hide();
        }
    });
}
